<template>
    <div class="components-time-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <div class="box-buzhou">
            <div class="line"></div>
            <img src="https://p5.ssl.qhimg.com/t110b9a93019dee4f6463c16cd4.png" alt="" />
        </div>
        <div class="box-list">
            <div class="list-item" v-for="item in props.data.list" :key="item.title">
                <img class="item-icon" :src="item.icon" alt="" />
                <div class="item-title">{{item.title}}</div>
                <div class="item-content">
                    {{item.desc}}
                </div>
            </div>
        </div>
        <div class="box-btn">
            <div class="btn-box" @click="jumpPath()">
                <img src="https://p3.ssl.qhimg.com/t110b9a930163dda967b4df4f09.png" alt="" />
                立即报名
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const jumpPath = () => {
  window.open(props.data.toUrl)
}
</script>

<style lang="scss" scoped>
.components-time-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 30px;
            height: 30px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 28px;
            font-weight: 700;
            line-height: 39px;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    .box-buzhou{
        width: 100%;
        position: absolute;
        top: 120px;
        z-index: 10;
        .line{
            width: 100%;
            height: 1px;
            background: rgb(30, 89, 191);
        }
        img{
            width: 14px;
            height: 14px;
            position: absolute;
            left: calc(100% - 14px);
            transform: translateY(-50%);
        }
    }
    .box-list{
        z-index: 11;
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 54px;
        padding: 0 180px 0 100px;
        .list-item{
            display: flex;
            flex-direction: column;
            align-items: center;
            .item-icon{
                width: 37px;
                height: 47px;
            }
            .item-title{
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2.0;
                font-size: 20px;
                font-weight: 700;
                line-height: 16px;
                letter-spacing: 0px;
                margin-top: 16px;
            }
            .item-content{
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2.0;
                font-size: 16px;
                font-weight: 400;
                line-height: 16px;
                letter-spacing: 0px;
                margin-top: 16px;
            }
        }
    }
    .box-btn{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 56px;
        .btn-box{
            cursor: pointer;
            width: 159.43px;
            height: 50px;
            border-radius: 8px;
            // background: linear-gradient(180.00deg, rgb(88, 142, 235),rgb(30, 89, 191) 100%);
            background-image: linear-gradient(45deg, rgb(30, 89, 191) 0%, rgb(88, 142, 235)  51%, rgb(30, 89, 191)  100%);
            display: flex;
            align-items: center;
            color: rgb(255, 255, 255);
            font-family: Alibaba PuHuiTi 3.0;
            font-size: 16px;
            font-weight: 500;
            justify-content: center;
            text-transform: uppercase;
            transition: 0.5s;
            background-size: 200% auto;
            border: 0px;
            box-shadow: 0px 0px 14px -7px rgb(88, 142, 235);
            img{
                height: 30px;
                margin-right: 12px;
            }
            &:hover {
                background-position: right center;
                /* change the direction of the change here */
                color: #fff;
                text-decoration: none;
            }
    
            &:active {
                transform: scale(0.95);
            }
        }

    }
}
</style>
